import { render, staticRenderFns } from "./mellat.vue?vue&type=template&id=7bc12112&scoped=true"
import script from "./mellat.vue?vue&type=script&lang=js"
export * from "./mellat.vue?vue&type=script&lang=js"
import style0 from "./mellat.vue?vue&type=style&index=0&id=7bc12112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc12112",
  null
  
)

export default component.exports